<script setup lang="ts">
/** Number line: the ticks left to right, and which one the kid should land on — keyed by tick id. */
import type { InputPrimaryEvent } from '@shared/ui/fields'
import type { MathExerciseEditorProps } from '../../../../../model/assignments/math-exercise-editors.hook'

import { AppText } from '@shared/ui/typography'
import { BtnCheckbox } from '@shared/ui/buttons'
import { InputPrimary } from '@shared/ui/fields'

import { useMathExerciseAnswerKey } from '../../../../../model/assignments/math-exercise-editors.hook'
import { MATH_NUMBER_LINE_MIN_TICKS } from '../../../../../lib/assignments/math-practice-schema'
import ExerciseItemList from '../ExerciseItemList.vue'

defineOptions({
  name: 'ExerciseNumberLine',
})

const props = defineProps<MathExerciseEditorProps>()

const {
  refCorrectId,
  setCorrectId,
} = useMathExerciseAnswerKey(() => props.exercise)
</script>

<template>
  <div class="exercise-number-line">
    <AppText
      name="body2"
      color="slate-500"
    >
      List the ticks from left to right as they sit on the line, and mark the one the kid should pick.
    </AppText>
    <ExerciseItemList
      :exercise="exercise"
      list="ticks"
      noun="tick"
      label="Ticks, left to right"
      :min="MATH_NUMBER_LINE_MIN_TICKS"
    >
      <template #item="{ row, update }">
        <BtnCheckbox
          text="Correct"
          class="exercise-number-line__correct"
          :checked="row.id === refCorrectId"
          @click="setCorrectId(row.id)"
        />
        <InputPrimary
          name="tick-label"
          class-name="exercise-number-line__label"
          :value="row.values.label"
          placeholder="e.g. 0, 1/2 or $\frac{3}{4}$"
          @input="(event: InputPrimaryEvent) => update({ label: String(event.value) })"
        />
      </template>
    </ExerciseItemList>
  </div>
</template>

<style scoped lang="scss" src="./ExerciseNumberLine.scss" />
